import { FetchResourceError } from '@/japi/types/FetchResourceError'

export const isErrorDocument = (japiDocument: any): japiDocument is FetchResourceError => typeof japiDocument === 'object' && japiDocument !== null && 'errors' in japiDocument && ! ('data' in japiDocument) // eslint-disable-line
